import clsx from 'clsx';
import { bg_color, text_color } from './colors';
import { Timer } from './timer';
import { W_Status } from '../api-new';

export const HeadingName = (ps: {
  name: string;
  status: W_Status;
  started_at?: number;
  size?: 'small' | 'large';
}) => {
  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center gap-4">
        {ps.size !== 'small' && (
          <div className="relative inline-flex">
            <div
              className={clsx('w-4 h-4 rounded-full', bg_color(ps.status))}
            />
            <div
              className={clsx(
                'w-6 h-6 rounded-full absolute -top-1 -left-1 animate-ping',
                bg_color(ps.status),
              )}
            />
            <div
              className={clsx(
                'w-6 h-6 rounded-full absolute -top-1 -left-1 animate-pulse',
                bg_color(ps.status),
              )}
            />
          </div>
        )}
        <h1 className="font-extrabold uppercase text-2xl">{ps.name}</h1>
      </div>
      <p
        className={clsx(
          'font-bold text-sm flex items-center gap-2',
          text_color(ps.status),
          ps.size !== 'small' && 'pl-8',
        )}>
        <span>{status_to_label(ps.status)}</span>
        {ps.started_at && (
          <>
            <span>•</span>
            <Timer start={ps.started_at} />
          </>
        )}
      </p>
    </div>
  );
};

const status_to_label = (status: W_Status) => {
  return W_Status[status];
};
